import { executeRequest, Request, Response } from '@jfs/network'
import { errorMessage } from '../../utils/string'
import { getAPIURL, getPaymentHeader } from '../config'

const responseParser = (response: Response) => {
  const { data } = response
  if (data?.status === 'SUCCESS') {
    return {
      status: 'SUCCESS',
      totalBalance: String(data?.totalBalance ?? ''),
    }
  } else {
    const customError = {
      message: errorMessage.defautCatchMessage,
    }
    throw customError
  }
}

export const getSodexoCardBalance = (cardDetails: any) => {
  const vaultId = cardDetails?.user?.vaultId
  const request: Request<{}> = {
    apiPath: getAPIURL('balance'),
    method: 'POST',
    body: cardDetails,
    headers: getPaymentHeader(),
  }

  return executeRequest(request)
    .then((data) => {
      return responseParser(data)
    })
    .catch((err) => {
      const { data } = err
      return {
        status: 'FAILED',
        totalBalance: '',
        message: data?.error?.message,
        vaultId,
      }

      // console.log('getSodexoCardBalance api error', error)
      // throw error
    })
}
